import React, { useState, useEffect } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import axios from 'axios';
import { toast } from 'react-toastify';

const CheckoutForm = ({ onSubmit , closePopUp }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [clientSecret, setClientSecret] = useState('');

  // Fetch the clientSecret from your backend
  useEffect(() => {
    async function fetchClientSecret() {
      const api = 'https://api.stripe.com/v1/';
      // const secretKey = config.STRIPE_SECRET_KEYS;
      const secretKey = process.env.REACT_APP_STRIPE_SECRET_KEYS;

      try {
        const response = await axios.post(
          `${api}payment_intents`,
          {
            amount: config.usamount * 100, 
            currency: 'usd',
          },
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': `Bearer ${secretKey}`,
            },
          }
        );
        if (response.status !== 200) {
          setErrorMessage('Failed to create payment intent');
        }

        const data = response.data;
        setClientSecret(data.client_secret); // Use `client_secret` from Stripe's response
      } catch (error) {
        setErrorMessage('Failed to load payment information. Please try again.');
      }
    }

    fetchClientSecret();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage('');

    if (!stripe || !elements || !clientSecret) {
      setErrorMessage('Stripe or client secret not loaded.');
      setLoading(false);
      return;
    }

    try {
      await elements.submit();
      const { error: paymentError, paymentIntent } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}/register`,
        },
      });

      if (paymentError) {
        setErrorMessage(paymentError.message);
      } else if (paymentIntent?.status === 'succeeded') {
        toast.success('Payment successful!');
        onSubmit(); // Handle post-payment logic
      } else {
        // console.error('Unexpected PaymentIntent status:', paymentIntent?.status);
        setErrorMessage('Unexpected payment status. Please try again.');
      }
    } catch (error) {
      setErrorMessage('Payment processing error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    
    <form onSubmit={handleSubmit}>
      {clientSecret ? (
        <PaymentElement />
      ) : (
        <p>Loading payment details...</p>
      )}
      {errorMessage && (
        <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
          {errorMessage}
        </div>
      )}
      <div className="d-flex mt-5 justify-content-between">
        <button
          type="submit"
          className="register-submit paybtn"
          style={{ width: '45%' }}
          disabled={!stripe || loading || !clientSecret}
        >
          {loading ? 'Processing...' : 'Pay Now'}
        </button>
        <button
          type="button"
          style={{
            background: '#ff5c5c',
            border: 'none',
            color: '#fff',
            letterSpacing: '1px',
            cursor: 'pointer',
            display: 'inline-block',
            fontSize: '14px',
            fontWeight: '700',
            width: '45%',
            padding: '10px 0',
            textTransform: 'uppercase',
            borderRadius: '3px',
            transition: 'all .50s ease-in-out',
          }}
          onClick={closePopUp}
        >
          Cancel Payment
        </button>
      </div>
    </form>
  );
};

export default CheckoutForm;
